import { constants } from '@bedc/constants';

import { Request } from '../../../../api/admin/principal/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const PrincipalAdminType = SearchDataTableType({
	request: Request,
	columnFields: constants.principal.search.adminColumnFields,
	filterIds: constants.principal.search.filterFields,
});
